import { RTKTags, api } from '@/store/api'

import Env from '../../../env/env'

import type {
  PaginationParams,
  AccountInfoResponse,
  RechargeHistoryResponse,
  AccountStatsResponse,
  AccountHistoryResponse,
  DeleteAccountResponse,
} from './Account.types'

export const accountApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // useGetAccountInfoQuery
    getAccountInfo: builder.query<AccountInfoResponse, void>({
      query: () => ({
        url: `${Env.BASE_API_URL}/api/v1/accounts`,
        method: 'GET',
      }),
      providesTags: [RTKTags.accountInfo],
    }),

    // useGetRechargeHistoryQuery
    getRechargeHistory: builder.query<
      RechargeHistoryResponse,
      PaginationParams
    >({
      query: (params) => ({
        url: `${Env.BASE_API_URL}/api/v1/accounts/recharge-history`,
        method: 'GET',
        params: {
          page: params.page,
          pageSize: params.pageSize,
        },
      }),
      providesTags: [RTKTags.userHistory],
    }),

    // useGetAccountStatsQuery
    getAccountStats: builder.query<AccountStatsResponse, void>({
      query: () => ({
        url: `${Env.BASE_API_URL}/api/v1/accounts/stats`,
        method: 'GET',
      }),
      providesTags: [RTKTags.monitoringCenter],
    }),

    // useGetAccountHistoryQuery
    getAccountHistory: builder.query<AccountHistoryResponse, PaginationParams>({
      query: (params) => ({
        url: `${Env.BASE_API_URL}/api/v1/accounts/history`,
        method: 'GET',
        params: {
          page: params.page,
          pageSize: params.pageSize,
        },
      }),
      providesTags: [RTKTags.historyAccount],
    }),

    // useDeleteAccountMutation
    deleteAccount: builder.mutation<DeleteAccountResponse, void>({
      query: () => ({
        url: `${Env.BASE_API_URL}/api/v1/accounts`,
        method: 'DELETE',
      }),
      invalidatesTags: [
        RTKTags.accountInfo,
        RTKTags.userInfo,
        RTKTags.historyAccount,
        RTKTags.userHistory,
      ],
    }),
  }),
})

export const {
  useGetAccountInfoQuery,
  useGetRechargeHistoryQuery,
  useGetAccountStatsQuery,
  useGetAccountHistoryQuery,
  useDeleteAccountMutation,
  useLazyGetAccountHistoryQuery,
} = accountApi
